module.exports = __webpack_public_path__ + "api-integration.j6XAtUL-.svg";